import React from 'react';
import HelpBadge from './components/HelpBadge';
import {
  annotateCrmTerms,
  crmGlossaryTerm,
  type CrmGlossaryTermId,
} from './crmGlossary';

export function CrmTermHelp({
  term,
  spanish = false,
}: {
  term: CrmGlossaryTermId;
  spanish?: boolean;
}) {
  const entry = crmGlossaryTerm(term);
  return (
    <HelpBadge label={spanish ? entry.label.es : entry.label.en}>
      {spanish ? entry.help.es : entry.help.en}
    </HelpBadge>
  );
}

export default function CrmTermText({
  text,
  spanish = false,
  seen,
}: {
  text: string;
  spanish?: boolean;
  seen?: Set<CrmGlossaryTermId>;
}) {
  return (
    <>
      {annotateCrmTerms(text, seen).map((chunk, index) =>
        chunk.termId ? (
          <span className="crm-term" data-crm-term={chunk.termId} key={`${chunk.termId}-${index}`}>
            {chunk.text}
            <CrmTermHelp term={chunk.termId} spanish={spanish} />
          </span>
        ) : (
          <React.Fragment key={`text-${index}`}>{chunk.text}</React.Fragment>
        ),
      )}
    </>
  );
}
